import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";
import { FC, useCallback, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Context } from "./context";

interface Props {
  children: React.ReactNode;
}

export const PromptContext: FC<Props> = ({ children }) => {
  const { t } = useTranslation();
  const cbReject = useRef<() => void>();
  const cbResolve = useRef<() => void>();
  const [open, setOpen] = useState(false);

  const showPrompt = useCallback(
    () =>
      new Promise<void>((resolve, reject) => {
        cbReject.current = reject;
        cbResolve.current = resolve;
        setOpen(true);
      }),
    []
  );

  const close = useCallback(() => {
    if (cbReject.current) {
      cbReject.current();
    }
    setOpen(false);
  }, []);

  const confirm = useCallback(() => {
    if (cbResolve.current) {
      cbResolve.current();
    }
    setOpen(false);
  }, []);

  return (
    <Context.Provider value={showPrompt}>
      {children}
      <Dialog open={open} onClose={close}>
        <DialogTitle sx={{ padding: "20px" }} id="alert-dialog-title">
          {t("prompt.title")}
        </DialogTitle>
        <DialogContent sx={{ padding: "20px" }}>
          <DialogContentText>{t("prompt.content")}</DialogContentText>
        </DialogContent>
        <DialogActions sx={{ padding: "20px" }}>
          <Button onClick={close} variant="text">
            {t("prompt.stay")}
          </Button>
          <Button onClick={confirm} autoFocus variant="contained">
            {t("prompt.leave")}
          </Button>
        </DialogActions>
      </Dialog>
    </Context.Provider>
  );
};
